import React, { useEffect, useState } from 'react'
import { Typography, Divider } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import moment from 'moment'
import { useScrollToBottom } from 'react-scroll-to-bottom'
import CustomScrollToBottom from '../../../components/CustomScrollToBottom'
import logsTarefasRepository from './LogsTarefasRepository'

const useStyles = makeStyles(theme => ({
  divAlteracao: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2)
  },
  scrollDiv: {
    height: 512
  }
}))

const buildPath = path => path.join(' - ')

const LogContent = ({ content }) => {
  return content
    .filter(field => field.path[0] !== 'updatedAt')
    .map((field, index) => (
      <Typography key={index}>
        {buildPath(field.path)}:{' '}
        {!!field.from && (
          <>
            De <b style={{ wordBreak: 'break-all' }}>{field.from}</b> Para
          </>
        )}{' '}
        {field.val ? (
          <>
            <b style={{ wordBreak: 'break-all' }}>{field.val}</b>
          </>
        ) : (
          <i>Vazio</i>
        )}
      </Typography>
    ))
}

const Content = ({ alteracoes, classes }) => {
  const scrollToBottom = useScrollToBottom()

  useEffect(() => {
    scrollToBottom()
  }, [alteracoes, scrollToBottom])

  return alteracoes.map(alteracao => (
    <div key={alteracao.id}>
      <div className={classes.divAlteracao}>
        <Typography>
          <b>{moment(alteracao.dataCriacao).format('DD/MM/YYYY HH:mm')}</b>
          {alteracao.usuario ? ` Por: ${alteracao.usuario.usuario}` : ''}
        </Typography>
        {alteracao.content && (
          <LogContent
            content={JSON.parse(alteracao.content)}
            classes={classes}
          />
        )}
      </div>
      <Divider />
    </div>
  ))
}

const LogAlteracoesCards = props => {
  const [alteracoes, setAlteracoes] = useState([])
  const classes = useStyles()

  useEffect(() => {
    async function fetchData() {
      const tarefaId = props.match.params.id
      const response = await logsTarefasRepository.list({
        query: {
          tarefaId
        }
      })
      if (response.ok) {
        setAlteracoes(response.data)
      }
    }
    fetchData()
  }, [props.match.params.id])

  return (
    <div>
      <Typography variant="h6" gutterBottom>
        Alterações na tarefa
      </Typography>
      <CustomScrollToBottom className={classes.scrollDiv}>
        <Content alteracoes={alteracoes} classes={classes} />
      </CustomScrollToBottom>
    </div>
  )
}

export default LogAlteracoesCards
